export function createActionTypes(namespace, requiredTypeNames) {
  const types = {};

  requiredTypeNames.forEach(typeName => {
    types[typeName] = namespace + "/" + typeName;
  });

  return types;
}
